import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  banner: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5),
    marginBottom: theme.spacing(3),
    color: '#172024',
    backgroundColor: '#FFF8E1',
    border: '1px solid #FFE082',
    borderRadius: 12,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  headerIcon: {
    color: '#FF9800',
    fontSize: 24,
    flexShrink: 0,
  },
  title: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  caption: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#3D4A51',
  },
  groupLabel: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#3D4A51',
    marginTop: theme.spacing(0.5),
  },
  groupLabelEmphasis: {
    fontWeight: 700,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    backgroundColor: '#FFFFFF',
    border: '1px solid #F0E3B5',
    borderRadius: 8,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  rowIcon: {
    display: 'flex',
    color: '#00234B',
    fontSize: 20,
    flexShrink: 0,
  },
  rowCopy: {
    flex: 1,
    minWidth: 0,
  },
  rowTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  rowDescription: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: '#3D4A51',
  },
  rowAlternative: {
    marginTop: theme.spacing(0.5),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: '#3D4A51',
  },
  rowAlternativeLink: {
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  rowActions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  actionButton: {
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
}))

export default useStyles
